import React from 'react';
import Layout from '../../components/Layout';
import MockLiveMonitor from '../../components/MockLiveMonitor';

export default function TutorMockTests() {
  return (
    <Layout role="tutor">
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '32px 24px' }}>
        <h1 style={{ margin: 0, fontSize: 26, fontWeight: 800, color: '#0D1B2A' }}>Mock Test Invigilation</h1>
        <p style={{ margin: '6px 0 24px', color: '#6B7280', fontSize: 15 }}>
          Candidates in the rooms assigned to you. Start the room (or individuals), pause, resume,
          or cancel as needed, and mark Writing/Speaking. Refreshes every 5 seconds.
        </p>
        <MockLiveMonitor showInvigilator={false} />
      </div>
    </Layout>
  );
}
